import React, { useEffect, useState } from 'react'
import { useRouteMatch } from 'react-router-dom'

import { Breadcrumb } from 'react-breadcrumbs'
import { Grid, Row, Col } from 'react-bootstrap'
import { PageTitle } from 'Components/PageTitle'
import { Breadcrumbs } from 'Components/Breadcrumbs'
import { SectionTitle } from 'Components/Section/SectionTitle'
import { AmbassadorWrapper } from 'Components/City/Page/Ambassador/AmbassadorWrapper'
import { AmbassadorSection } from 'Components/City/Page/Ambassador/AmbassadorSection'
import { HideWhenBlocked } from 'Containers/UIBlock/HideWhenBlocked'
import PinUserIcon from 'Assets/Images/icons/pinUser'
import { PATHS } from 'Config/Routing/paths'
import AmbassadorUploadDocumentsWrapper from '../../Ambasador/UploadDocuments/UploadDocumentsForm'
import { getSpy } from '../gql'

const BreadcrumbsAmbassadorUploadDocuments = ({ currentPath }) => {
  return (
    <div>
      <Breadcrumbs icon={<PinUserIcon style={{ width: 16 }} />} />
      <Breadcrumb
        data={{ title: 'Dashboard', pathname: `${PATHS.main.dashboard}` }}
      />
      <Breadcrumb
        data={{
          title: 'Cities',
          pathname: `${PATHS.main.dashboard}${PATHS.dashboard.cities}`,
        }}
      />
      <Breadcrumb
        data={{
          title: 'Spy',
          pathname: currentPath.replace('/upload-documents', ''),
        }}
      />
      <Breadcrumb data={{ title: 'Documents', pathname: currentPath }} />
    </div>
  )
}

const SpyUploadDocuments = ({ countryCode }) => {
  const match = useRouteMatch()
  const {
    params: { spyId },
  } = match

  const [spy, setSpy] = useState(null)

  useEffect(() => {
    fetchSpy()
  }, [])

  const fetchSpy = async () => {
    const res = await getSpy({ id: spyId })

    const result = await res.json()

    result.data.spy.signedLegalDocuments = result.data.spy.signedLegalDocuments.edges.map(
      e => ({
        dateTime: e.node.dateTime,
        name: e.node.legalDocument.name,
        url: e.node.legalDocument.url,
      }),
    )
    setSpy(result.data.spy)
  }

  if (!spy) {
    return null
  }

  return (
    <HideWhenBlocked>
      <AmbassadorWrapper>
        <BreadcrumbsAmbassadorUploadDocuments currentPath={match.url} />
        <PageTitle>
          {spy.firstName} {spy.lastName}
          {spy.status && <span className="status">({spy.status})</span>}
        </PageTitle>

        <AmbassadorSection>
          <Grid fluid>
            <Row>
              <Col xs={12}>
                <SectionTitle>Upload spy documents</SectionTitle>
              </Col>
            </Row>
            <Row>
              <Col xs={12}>
                {spy.id && (
                  <AmbassadorUploadDocumentsWrapper
                    ambassadorId={spy.id}
                    countryCode={countryCode}
                  />
                )}
              </Col>
            </Row>
          </Grid>
        </AmbassadorSection>
      </AmbassadorWrapper>
    </HideWhenBlocked>
  )
}

export default SpyUploadDocuments



// WEBPACK FOOTER //
// ./src/Containers/City/Page/Spies/UploadDocuments/index.js